import {Terminal} from "../../../models/response/terminal.response";

interface Props {
  terminal: Terminal
}

function MarkerPopupContent(props: Props) {
  const {terminal} = props;

  return <div className={'map-popup-text'}>
    <div className={''}> ترمینال {terminal.terminalNo}</div>
    <hr style={{margin: '8px 0'}}/>
    <div className={'mt-1'}>{terminal.street}</div>
  </div>;
}


export default MarkerPopupContent
